import { useEffect } from "react";
import Lenis from "lenis";
import Navigation from "@/components/sections/Navigation";
import Hero from "@/components/sections/Hero";
import Marquee from "@/components/sections/Marquee";
import About from "@/components/sections/About";
import Founder from "@/components/sections/Founder";
import Services from "@/components/sections/Services";
import WhyAxomind from "@/components/sections/WhyAxomind";
import Stats from "@/components/sections/Stats";
import Calculators from "@/components/sections/Calculators";
import Quizzes from "@/components/sections/Quizzes";
import GuideDownload from "@/components/sections/GuideDownload";
import Testimonials from "@/components/sections/Testimonials";
import FAQ from "@/components/sections/FAQ";
import BlogPreview from "@/components/sections/BlogPreview";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";
import FloatingButtons from "@/components/sections/FloatingButtons";
import AIChatbot from "@/components/sections/AIChatbot";
import CookieBanner from "@/components/sections/CookieBanner";

export default function HomePage() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  const scrollTo = (sel) => {
    const el = document.querySelector(sel);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const openBookMeeting = () => {
    window.dispatchEvent(new CustomEvent("open-book-meeting"));
  };

  return (
    <div className="min-h-screen bg-[#050505] text-white overflow-x-hidden" data-testid="home-page">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:px-4 focus:py-2 focus:bg-[#D4AF37] focus:text-black focus:rounded-full"
      >
        Skip to content
      </a>
      <Navigation />
      <main id="main-content">
        <Hero
          onPrimary={openBookMeeting}
          onSecondary={() => scrollTo("#services")}
        />
        <Marquee />
        <About />
        <Founder />
        <Services />
        <Stats />
        <WhyAxomind />
        <Calculators />
        <Quizzes />
        <GuideDownload />
        <Testimonials />
        <BlogPreview />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <FloatingButtons />
      <AIChatbot />
      <CookieBanner />
    </div>
  );
}
